module.exports = __webpack_public_path__ + "static/media/doomsday.cc75643.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/doomsday.mp3
// module id = nwda
// module chunks = 1